
export const COLUMNS = [
  {
    Header: 'Forms',
    accessor: 'name',
  }
]
